import { Group } from '../../model/group/group.model';
import { ErrorRestST } from '../../rest/rest.model';

export const nameReducer = 'groups';
export interface GroupsState {
  treeGroups: Group[];
  // some pages load only one group
  individualGroup?: Group;
  loading: boolean;
  error?: ErrorRestST;
  activatedLoadingGroupsDevices?: boolean;
}
export type IconUpload = {
  fileName?: string;
  toolTip?: string;
  file: File;
  imagePreviewUrl: string;
};
